import { useEffect, useState } from 'react'
import { scrollState } from './scrollState'

function smoothstep(x, a, b) {
  const t = Math.max(0, Math.min(1, (x - a) / (b - a)))
  return t * t * (3 - 2 * t)
}

export default function EndCard() {
  const [, force] = useState(0)
  useEffect(() => {
    let raf
    const loop = () => {
      force((n) => (n + 1) & 0xff)
      raf = requestAnimationFrame(loop)
    }
    raf = requestAnimationFrame(loop)
    return () => cancelAnimationFrame(raf)
  }, [])

  const t = scrollState.offset
  // EndCard appears only AFTER Beat 5 has fully scrolled out of the viewport.
  // 150vh runway after Beat 5 gives a clean handoff window.
  const op = smoothstep(t, 0.94, 0.99)
  if (op <= 0.01) return null

  // Detect mobile to switch between centered (mobile) and right-half (desktop) layout.
  const isMobile = typeof window !== 'undefined' && window.matchMedia('(max-width: 768px)').matches

  const positionStyles = isMobile
    ? {
        top: '50%',
        left: '50%',
        transform: `translate(-50%, calc(-50% + ${(1 - op) * 30}px))`,
        maxWidth: 'min(560px, 92vw)',
        textAlign: 'center',
      }
    : {
        // Desktop: centred over the baby image. Beat 5 copy fades out so it doesn't
        // compete for screen space.
        top: '50%',
        left: '50%',
        transform: `translate(-50%, calc(-50% + ${(1 - op) * 30}px))`,
        maxWidth: 'min(480px, 46vw)',
        textAlign: 'center',
      }

  return (
    <div
      style={{
        position: 'fixed',
        ...positionStyles,
        opacity: op,
        zIndex: 6,
        pointerEvents: op > 0.5 ? 'auto' : 'none',
        background: 'rgba(247, 248, 245, 0.96)',
        padding: 'clamp(1.6rem, 3vw, 2.4rem) clamp(2rem, 4vw, 3rem)',
        borderRadius: 14,
        boxShadow: '0 30px 80px rgba(0,0,0,0.22)',
        backdropFilter: 'blur(8px)',
      }}
    >
      <a href="https://aqi0.com/" aria-label="aqi0 home" style={{ display: 'inline-block' }}>
        <img
          src={import.meta.env.BASE_URL + 'aqi0-logo.png'}
          alt="aqi0"
          style={{ height: 'clamp(40px, 5vw, 56px)', width: 'auto', display: 'inline-block' }}
        />
      </a>
      <div
        style={{
          marginTop: '1.6rem',
          display: 'flex',
          gap: '0.7rem',
          flexWrap: 'wrap',
          justifyContent: 'center',
        }}
      >
        <a href="https://aqi0.com/air-purifier/" style={pillBtn}>
          Know more
        </a>
        <a
          href="https://wa.me/919667672740?text=Hi%20aqi0%2C%20I%20saw%20the%20%2Fair%2F%20page%20-%20can%20we%20talk%3F"
          style={pillBtn}
          aria-label="Talk to us on WhatsApp"
        >
          <svg viewBox="0 0 24 24" width="14" height="14" fill="currentColor" aria-hidden="true" style={{ marginRight: 6, verticalAlign: 'middle' }}>
            <path d="M.057 24l1.687-6.163a11.867 11.867 0 01-1.587-5.945C.16 5.335 5.495 0 12.05 0a11.821 11.821 0 018.413 3.488 11.824 11.824 0 013.48 8.414c-.003 6.555-5.338 11.892-11.893 11.892a11.9 11.9 0 01-5.688-1.448L.057 24zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 001.595 5.371l-.999 3.648 3.893-.718zM17.473 14.382c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413z"/>
          </svg>
          Talk to us
        </a>
      </div>

      <div
        style={{
          marginTop: '1.3rem',
          fontSize: '0.78rem',
          color: 'rgba(60,60,60,0.72)',
          display: 'flex',
          gap: '0.9rem',
          flexWrap: 'wrap',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <a href="https://aqi0.com/how-it-works/" style={linkSub}>How it works</a>
        <span style={dotSep}>·</span>
        <a href="https://aqi0.com/learn/are-air-purifiers-enough-delhi/" style={linkSub}>Air purifiers vs aqi0</a>
        <span style={dotSep}>·</span>
        <a href="https://aqi0.com/pricing/" style={linkSub}>Pricing</a>
        <span style={dotSep}>·</span>
        <a href="https://youtu.be/tUWAX2ymW_g" style={linkSub} target="_blank" rel="noopener noreferrer">Watch the 8-min version</a>
      </div>

      <div
        style={{
          marginTop: '1.3rem',
          display: 'flex',
          gap: '0.9rem',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <SocialIcon href="https://www.instagram.com/aqi0.in/" label="Instagram">
          <path d="M12 2.16c3.2 0 3.58.01 4.85.07 1.17.05 1.8.25 2.23.41.56.22.96.48 1.38.9.42.42.68.82.9 1.38.16.42.36 1.05.41 2.22.06 1.27.07 1.65.07 4.85s-.01 3.58-.07 4.85c-.05 1.17-.25 1.8-.41 2.22-.22.56-.48.96-.9 1.38a3.7 3.7 0 0 1-1.38.9c-.42.16-1.05.36-2.22.41-1.27.06-1.65.07-4.85.07s-3.58-.01-4.85-.07c-1.17-.05-1.8-.25-2.23-.41a3.7 3.7 0 0 1-1.38-.9 3.7 3.7 0 0 1-.9-1.38c-.16-.42-.36-1.05-.41-2.22C2.17 15.58 2.16 15.2 2.16 12s.01-3.58.07-4.85c.05-1.17.25-1.8.41-2.23.22-.56.48-.96.9-1.38.42-.42.82-.68 1.38-.9.42-.16 1.05-.36 2.23-.41C8.42 2.17 8.8 2.16 12 2.16Zm0 2.16c-3.15 0-3.5.02-4.72.07-1.07.05-1.65.23-2.04.38-.51.2-.88.44-1.27.83a3.42 3.42 0 0 0-.83 1.27c-.15.39-.33.97-.38 2.04C2.7 9.96 2.7 10.31 2.7 12s0 2.04.06 3.27c.05 1.07.23 1.65.38 2.04.2.51.44.88.83 1.27.39.39.76.63 1.27.83.39.15.97.33 2.04.38 1.22.05 1.57.07 4.72.07s3.5-.02 4.72-.07c1.07-.05 1.65-.23 2.04-.38.51-.2.88-.44 1.27-.83.39-.39.63-.76.83-1.27.15-.39.33-.97.38-2.04.05-1.22.07-1.57.07-4.72s-.02-3.5-.07-4.72c-.05-1.07-.23-1.65-.38-2.04a3.42 3.42 0 0 0-.83-1.27 3.42 3.42 0 0 0-1.27-.83c-.39-.15-.97-.33-2.04-.38-1.22-.05-1.57-.07-4.72-.07Zm0 3.68a4 4 0 1 1 0 8 4 4 0 0 1 0-8Zm0 2.16a1.84 1.84 0 1 0 0 3.68 1.84 1.84 0 0 0 0-3.68Zm5.1-2.4a.96.96 0 1 0 0-1.92.96.96 0 0 0 0 1.92Z"/>
        </SocialIcon>
        <SocialIcon href="https://twitter.com/aqi0in" label="X / Twitter">
          <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231ZM17.083 19.77h1.833L7.084 4.126H5.117L17.083 19.77Z"/>
        </SocialIcon>
        <SocialIcon href="https://www.youtube.com/@aqi0in" label="YouTube">
          <path d="M23.5 6.2a3 3 0 0 0-2.1-2.13C19.6 3.6 12 3.6 12 3.6s-7.6 0-9.4.47A3 3 0 0 0 .5 6.2 31.2 31.2 0 0 0 0 12c0 1.9.16 3.84.5 5.8a3 3 0 0 0 2.1 2.13c1.8.47 9.4.47 9.4.47s7.6 0 9.4-.47a3 3 0 0 0 2.1-2.13c.34-1.96.5-3.9.5-5.8 0-1.93-.17-3.86-.5-5.8ZM9.6 15.6V8.4l6.24 3.6L9.6 15.6Z"/>
        </SocialIcon>
        <SocialIcon href="https://www.facebook.com/aqi0.in" label="Facebook">
          <path d="M22 12a10 10 0 1 0-11.56 9.88V14.9H7.9v-2.9h2.54v-2.2c0-2.5 1.49-3.89 3.78-3.89 1.09 0 2.24.2 2.24.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56V12h2.77l-.44 2.9h-2.33v6.98A10 10 0 0 0 22 12Z"/>
        </SocialIcon>
      </div>
    </div>
  )
}

function SocialIcon({ href, label, children }) {
  return (
    <a
      href={href}
      aria-label={label}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        width: 30,
        height: 30,
        borderRadius: 999,
        background: 'rgba(27,58,92,0.08)',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#1B3A5C',
        transition: 'background 0.15s ease',
      }}
      onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(27,58,92,0.18)')}
      onMouseLeave={(e) => (e.currentTarget.style.background = 'rgba(27,58,92,0.08)')}
    >
      <svg viewBox="0 0 24 24" width="15" height="15" fill="currentColor" aria-hidden="true">
        {children}
      </svg>
    </a>
  )
}

// Single shared style — both CTAs are the same size, same green pill.
const pillBtn = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '0.85rem 1.5rem',
  background: '#8AB63F',
  color: '#fff',
  borderRadius: 999,
  textDecoration: 'none',
  fontWeight: 600,
  fontSize: '0.98rem',
  boxShadow: '0 6px 20px rgba(138,182,63,0.35)',
  minWidth: 140,
}

const linkSub = {
  color: '#1B3A5C',
  textDecoration: 'none',
  fontWeight: 500,
}

const dotSep = { color: 'rgba(60,60,60,0.4)' }
